"use strict";

var _interopRequireDefault = require("D:/work/code/aihuz/arbitration-ui/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es6.function.name");
require("core-js/modules/web.dom.iterable");
var _index = _interopRequireDefault(require("@/views/caseConditions/index.vue"));
var _inquiry = require("@/api/inquiry.js");
var _dictionary = require("@/config/dictionary");
var _send = _interopRequireDefault(require("./send"));
var _index2 = require("@/utils/index.js");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
// 你判断下，只有status等于3的，才能显示补正书送达，等于5或者等于1的，都可以编辑补正书送审吧。
var _default = {
  name: 'ruleSend',
  data: function data() {
    return {
      tableHeaderColor: this.$tableHeaderColor,
      loading: true,
      currentPage: 1,
      pageLimit: 10,
      //每页请求多少个数据，默认10
      pageSizes: this.$tablePageSizes,
      tableData: [],
      secretaryList: [],
      total: 0,
      //总页数
      conditionData: '',
      //来自子组件的数据
      caseState: _dictionary.dictionary.caseState,
      multipleSelection: [],
      multipleSelectionId: [],
      wayList: [{
        name: '书面审理',
        id: '1'
      }, {
        name: '线下开庭',
        id: '2'
      }, {
        name: '视频开庭',
        id: '3'
      }],
      divisionLotVisible: false,
      //案件组庭批量弹窗显示
      divisionLotForm: {
        //案件组庭批量数据
        chiefArbitratorId: "",
        chiefArbitratorName: '',
        trialWay: ''
      },
      divisionLotRules: {
        chiefArbitratorId: [{
          required: true,
          message: '请选择首席仲裁员',
          trigger: 'change'
        }],
        trialWay: [{
          required: true,
          message: '请选择审理方式',
          trigger: 'change'
        }]
      },
      divisionVisible: false,
      //案件组庭弹窗显示
      divisionForm: {
        //案件组庭数据
        chiefArbitratorId: "",
        chiefArbitratorName: '',
        secondArbitratorId: '',
        secondArbitratorName: '',
        thirdArbitratorId: '',
        thirdArbitratorName: '',
        trialWay: ''
      },
      divisionRules: {
        chiefArbitratorId: [{
          required: true,
          message: '请选择首席仲裁员',
          trigger: 'change'
        }],
        trialWay: [{
          required: true,
          message: '请选择审理方式',
          trigger: 'change'
        }]
      },
      caseId: '',
      caseNum: '',
      node: '',
      arbitratorList: [],
      partyChoiceArb: {
        appArbitratorName: '',
        resArbitratorName: '',
        content: '',
        replyName: '',
        href: '',
        secretaryId: '',
        opinion: '',
        secretaryName: ''
      },
      allLoading: false,
      //全屏loading
      sendCaseVisible: false,
      //案件送达
      gotoServicing: false //选定仲裁员弹窗 按钮loading
    };
  },
  created: function created() {
    this.init();
  },
  components: {
    Caseconditons: _index.default,
    SendCase: _send.default
  },
  methods: {
    init: function init() {
      var _this = this;
      (0, _inquiry.getList)({
        state: '41',
        limit: this.pageLimit,
        page: this.currentPage
      }).then(function (res) {
        if (res.code == 1) {
          _this.tableData = res.rows;
          _this.total = res.total;
          _this.loading = false;
        }
      });
    },
    handleDetail: function handleDetail(val) {
      this.$router.push({
        name: 'inquiryDetail',
        params: {
          caseId: val
        }
      });
    },
    //点击筛选，发送请求列表
    checkList: function checkList(data) {
      var _this2 = this;
      // 需要发送给后端的数据
      this.currentPage = 1;
      var postData = {
        caseId: data.caseId,
        caseNo: data.caseNo,
        partyName: data.partyName,
        defenceState: data.replyvalue,
        beginCtime: data.rowSecondDate[0],
        endCtime: data.rowSecondDate[1],
        caseType: data.caseTypevalue,
        beginRegisterTime: data.rowThirdDate[0],
        endRegisterTime: data.rowThirdDate[1],
        source: data.caseOriginvalue,
        state: '41',
        limit: this.pageLimit,
        page: 1
      };
      this.conditionData = postData;
      (0, _inquiry.getList)(this.conditionData).then(function (res) {
        if (res.code == 1) {
          _this2.tableData = res.rows;
          _this2.total = res.total;
        }
      });
    },
    //点击 清空所有筛选条件
    cleanConditionData: function cleanConditionData() {
      this.conditionData = '';
      this.currentPage = 1;
      this.init();
    },
    //表格禁止勾选事件
    selectable: function selectable(row, index) {
      if (row.arbitratorName) {
        return true;
      } else {
        return false;
      }
    },
    // 表格勾选事件
    handleSelectionChange: function handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    //审核
    handleReview: function handleReview(data) {
      var _this3 = this;
      this.caseId = data.caseId;
      this.sendCaseVisible = true;
      this.$nextTick(function () {
        _this3.$refs.sendCase.init(_this3.caseId, 41);
      });
    },
    updateShow: function updateShow() {
      this.divisionVisible = false;
      this.sendCaseVisible = true;
      this.gotoServicing = false;
      this.allLoading = false;
    },
    updateErrorShow: function updateErrorShow() {
      this.sendCaseVisible = false;
      this.gotoServicing = false;
      this.allLoading = false;
    },
    // 审核通过后刷新数据
    refreshPage: function refreshPage() {
      this.allLoading = false;
      this.sendCaseVisible = false;
      this.init();
    },
    //进行组庭
    caseCourtAdopt: function caseCourtAdopt(divisionForm) {
      var _this4 = this;
      this.$refs[divisionForm].validate(function (valid) {
        if (valid) {
          (0, _inquiry.procedureByAdopt)({
            caseId: _this4.caseId,
            node: _this4.node,
            reviewId: _this4.partyChoiceArb.secretaryId,
            reviewName: _this4.partyChoiceArb.secretaryName,
            content: _this4.partyChoiceArb.opinion
          }).then(function (res) {
            if (res.code == 1) {
              _this4.$message({
                message: '进行组庭成功',
                type: 'success'
              });
              _this4.divisionVisible = false;
              _this4.init();
            }
          });
        }
      });
    },
    //批量审核
    batchReview: function batchReview() {
      var _this5 = this;
      this.caseNum = this.multipleSelectionId.length;
      this.$confirm('确定批量送达？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        _this5.multipleSelectionId = [];
        _this5.multipleSelection.forEach(function (item) {
          _this5.multipleSelectionId.push(item.caseId);
        });
        (0, _inquiry.batchTask)({
          caseIds: _this5.multipleSelectionId,
          caseState: 41,
          content: ''
        }).then(function (res) {
          if (res.code == 1) {
            _this5.sumbiting = false;
            _this5.$message({
              message: '批量操作成功',
              type: 'success'
            });
            _this5.caseBriefVisible = false;
            _this5.init();
          } else {
            _this5.$message.error(res.msg);
          }
        });
      });
    },
    batchReviewSubmit: function batchReviewSubmit(divisionLotForm) {
      var _this6 = this;
      this.$refs[divisionLotForm].validate(function (valid) {
        if (valid) {
          _this6.arbitratorList.forEach(function (item) {
            if (item.id == _this6.divisionLotForm.chiefArbitratorId) {
              _this6.divisionLotForm.chiefArbitratorName = item.name;
            }
          });
          _this6.divisionLotForm.caseIds = _this6.multipleSelectionId;
          (0, _inquiry.batchSendCompose)(_this6.divisionLotForm).then(function (res) {
            if (res.code == 1) {
              _this6.$message({
                message: '批量审核成功',
                type: 'success'
              });
              _this6.divisionLotVisible = false;
              _this6.init();
              // 批量送达页面？？？
            } else {
              _this6.$message.error(res.msg);
            }
          });
        } else {
          return false;
        }
      });
    },
    // 分页
    handleSizeChange: function handleSizeChange(val) {
      var _this7 = this;
      this.pageLimit = val;
      if ((0, _index2.hasValueInObj)(this.conditionData)) {
        // 有筛选条件的情况下
        this.conditionData.limit = val;
        this.conditionData.page = this.currentPage;
        (0, _inquiry.getList)(this.conditionData).then(function (res) {
          if (res.code == 1) {
            _this7.tableData = res.rows;
            _this7.total = res.total;
          }
        });
      } else {
        //没有筛选条件的情况下
        (0, _inquiry.getList)({
          state: '41',
          limit: val,
          page: this.currentPage
        }).then(function (res) {
          if (res.code == 1) {
            _this7.tableData = res.rows;
            _this7.total = res.total;
          }
        });
      }
    },
    handleCurrentChange: function handleCurrentChange(val) {
      var _this8 = this;
      if ((0, _index2.hasValueInObj)(this.conditionData)) {
        // 有筛选条件的情况下
        this.conditionData.page = val;
        this.conditionData.limit = this.pageLimit;
        (0, _inquiry.getList)(this.conditionData).then(function (res) {
          if (res.code == 1) {
            _this8.tableData = res.rows;
            _this8.total = res.total;
            _this8.currentPage = val;
          }
        });
      } else {
        //没有筛选条件的情况下
        (0, _inquiry.getList)({
          state: '41',
          limit: this.pageLimit,
          page: val
        }).then(function (res) {
          if (res.code == 1) {
            _this8.tableData = res.rows;
            _this8.total = res.total;
            _this8.currentPage = val;
          }
        });
      }
    }
  }
};
exports.default = _default;